const Cookies = {
    delete: (name) => {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/signup';
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
    }
};

export default Cookies;